import { userTypes } from "../constants/action-types";
import { myReducerPersist } from "../store/managerLocalStorage";

const initialState = {
  user: {},
  selectedBranch: null, // { branchId, branchName, headBranchId, headBranchName }
  userAuths: [], // 개별 액션 권한 목록 [{ menuAuthId, menuAuthCode, authYn, ... }]
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userTypes.SET_USER:
      return {
        ...state,
        user: action.data,
      };
    case userTypes.REMOVE_USER:
      return initialState;
    case userTypes.SET_USER_AUTHS:
      return {
        ...state,
        userAuths: action.data,
      };
    case userTypes.SET_SELECTED_BRANCH:
      return {
        ...state,
        selectedBranch: action.data,
        // user.branch와 user.headBranch도 함께 업데이트 (다른 페이지에서 사용)
        user: {
          ...state.user,
          branch: {
            branchId: action.data.branchId,
            branchName: action.data.branchName,
          },
          headBranch: {
            headBranchId: action.data.headBranchId,
            headBranchName: action.data.headBranchName,
          },
        },
      };
    default:
      return state;
  }
};

export default myReducerPersist({ key: "pila-user" }, userReducer);
